import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../resources/requestInfo";

import { deleteAccountRoutes } from "./routes";

export interface IDeleteAccountResponse {
  success: boolean;
  message: string;
}

export const fetchDeleteAccount = createAsyncThunk<IDeleteAccountResponse>(
  "deleteAccount/fetchDeleteAccount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(deleteAccountRoutes.DELETE_ACCOUNT);
      return response.data;
    } catch (error: any) {
      console.log("error fetchDeleteAccount >>>", error);
      return rejectWithValue(error.response?.data?.message || "Ошибка удаления аккаунта");
    }
  }
);
